import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DarkTooltip } from '@framework/ui/atoms/Tooltip';
import { useTranslation } from 'react-i18next';
export const ReadonlyIcon: React.FC<unknown> = () => {
  const { t } = useTranslation();
  return (
    <DarkTooltip tooltip={t('viewModel.readonlyIcon.tooltip')} placement="bottom">
      <div className={'flex size-10 cursor-pointer items-center justify-center text-gray-400'}>
        <FontAwesomeIcon icon={faEye} />
      </div>
    </DarkTooltip>
  );
};
